import { PricingCardStaticDetailsTypes } from '../../../../../partner-pages/page-sections/eas-section/expertPlans/card-details.constants';
import { TPricingPlans } from '../../../types';
import { PricingCard } from '../pricing-card/pricing-card.component';

export const PricingCardWrapper = ({
  PricingCardStaticDetails,
  pricingPlanData,
}: {
  PricingCardStaticDetails: PricingCardStaticDetailsTypes[];
  pricingPlanData: TPricingPlans[];
}) => {
  // Filtering out luxury plan
  const filteredPlans = pricingPlanData
    .map((plan, index) => ({
      plan,
      card: PricingCardStaticDetails[index],
    }))
    .filter(({ plan }) => plan.externalId !== 'prod_itr_af_luxury');

  return (
    <div
      className="grid grid-cols-3 gap-8 lg:grid-cols-2 items-center sm:grid sm:grid-cols-1 flex-wrap md:grid md:grid-cols-2 md:gap-4 mt-3"
      id="pricing-card"
    >
      {filteredPlans.map(({ plan, card }) => (
        <PricingCard key={plan.externalId} card={card} pricingPlanData={plan} />
      ))}
    </div>
  );
};
